export default __webpack_public_path__ + "static/media/sortingIcon.4ed8de5b.svg";